import React, {createContext, useEffect, useState} from "react";

export const DeviceContext = createContext();

export default function DeviceProvider(props){
    
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    
    useEffect(()=>{
        window.addEventListener('resize', handleResize);
        return ()=>{
            window.removeEventListener('resize', handleResize);
        }

    }, []);

    const handleResize = () =>{
        setIsMobile(window.innerWidth<=768);
    }

    return(
        <DeviceContext.Provider value={{
            isMobile,
            setIsMobile
        }}
        >
            {props.children}
        </DeviceContext.Provider>
    )
}